import axios from 'axios';
import store from '../stateStore';

axios.interceptors.request.use((request) => {
  request.headers.common['X-XSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  return request;
});

axios.interceptors.response.use(
  response => response,
  (error) => {
    const {
      response: { status },
    } = error;

    switch (status) {
      case 500:
        store.dispatch('toasts/addToGlobalToastQueue', {
          color: 'error',
          message: 'A server issue has occurred. This has been recorded, but you should still talk to a developer for further assistance.',
          multiline: true,
        });
        break;
      default:
        break;
    }

    return Promise.reject(error);
  },
);
